import axios from 'axios'
import store from '@/store'

const API_BASE_URL = process.env.VUE_APP_API_URL || 'https://clubtest.intrare.app'

function getHeaders () {
  return {
    'Content-Type': 'application/json',
    'Authorization': `Token ${store.getters.getToken}`
  }
}

export const handicapAPI = {
  // GET /golf/player-handicaps/my_handicap/ - Mi handicap actual
  getMyHandicap () {
    return axios.get(`${API_BASE_URL}/golf/player-handicaps/my_handicap/`, {
      headers: getHeaders()
    })
  },

  // GET /golf/player-handicaps/{user_id}/ - Handicap de un usuario específico
  getUser (userId) {
    return axios.get(`${API_BASE_URL}/golf/player-handicaps/${userId}/`, {
      headers: getHeaders()
    })
  },

  // GET /golf/player-handicaps/ - Listar todos los handicaps (Admin/RP)
  list (params = {}) {
    return axios.get(`${API_BASE_URL}/golf/player-handicaps/`, {
      headers: getHeaders(),
      params
    })
  },

  // GET /golf/golf-scores/?user_id={user_id} - Scores de un usuario (para histórico)
  getUserScores (userId, params = {}) {
    return axios.get(`${API_BASE_URL}/golf/golf-scores/`, {
      headers: getHeaders(),
      params: { user_id: userId, ...params }
    })
  },

  // GET /golf/golf-scores/{score_id}/scorecard/ - Detalle scorecard con handicap
  getScorecard (scoreId) {
    return axios.get(`${API_BASE_URL}/golf/golf-scores/${scoreId}/scorecard/`, {
      headers: getHeaders()
    })
  },

  // GET /golf/score-audit-logs/ - Auditoría de cambios de handicap (Admin)
  getAuditLog (params = {}) {
    return axios.get(`${API_BASE_URL}/golf/score-audit-logs/`, {
      headers: getHeaders(),
      params
    })
  }
}
